import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_matchinpay_reload",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header flex-stack" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "Reload MG Pay", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body scroll-y pt-10 pb-15 px-lg-17" }
const _hoisted_8 = { class: "card-body py-3" }
const _hoisted_9 = {
  key: 0,
  class: "col-xxl-12"
}
const _hoisted_10 = { class: "row mb-5" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_12 = { class: "col-xxl-8 row" }
const _hoisted_13 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Select Top-up Source", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("option", { value: "1" }, "DTC Balance", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: "2" }, "Instapay QRPh", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_17 = { class: "row mb-5" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_19 = { class: "col-xxl-8" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", {
  for: "option1",
  class: "custom-radio-label"
}, "2,000", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("label", {
  for: "option2",
  class: "custom-radio-label"
}, "5,000", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_24 = { class: "row mb-5" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_26 = { class: "col-xxl-8 text-center" }
const _hoisted_27 = /*#__PURE__*/_createVNode("label", { class: "col-lg-6 col-form-label fw-bold fs-3 text-left" }, [
  /*#__PURE__*/_createVNode("b", null, "TOTAL: ")
], -1)
const _hoisted_28 = { class: "col-lg-6 col-form-label fw-bold fs-3 text-right" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-2" }, null, -1)
const _hoisted_30 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_32 = { class: "col-md-6 fv-row py-6 text-center" }
const _hoisted_33 = {
  key: 1,
  href: "#",
  class: "btn btn-sm btn-success",
  "data-bs-toggle": "modal"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_36 = {
  key: 1,
  class: "row mb-5"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_38 = { class: "col-md-6 fv-row py-6 text-center" }
const _hoisted_39 = {
  key: 1,
  href: "#",
  class: "btn btn-sm btn-success",
  "data-bs-toggle": "modal"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_41 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_42 = {
  key: 1,
  class: "col-xxl-12"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "row mb-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-md-12 fv-row py-1" }, [
    /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, [
      /*#__PURE__*/_createVNode("span", { class: "" }, "Please input the OTP sent to your mobile phone.")
    ])
  ])
], -1)
const _hoisted_44 = { class: "row mb-5" }
const _hoisted_45 = { class: "col-md-12 fv-row py-1 text-center" }
const _hoisted_46 = { class: "row mb-5" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)
const _hoisted_48 = { class: "col-md-6 fv-row py-6 text-center" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_50 = {
  key: 1,
  href: "#",
  class: "btn btn-sm btn-success",
  "data-bs-toggle": "modal"
}
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "col-md-3 fv-row py-3 text-center" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.reset_matchinpay();})
            }, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_ctx.hasPendingMatchinPayOTP == false )
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode("div", _hoisted_12, [
                        _withDirectives(_createVNode("select", {
                          class: "form-select form-select-solid form-select-lg fw-bold mb-10",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.topupfrom = $event)),
                          onChange: _cache[3] || (_cache[3] = ($event: any) => {_ctx.selectTopUpFrom();})
                        }, [
                          _hoisted_13,
                          _hoisted_14,
                          _hoisted_15
                        ], 544), [
                          [_vModelSelect, _ctx.topupfrom]
                        ])
                      ]),
                      _hoisted_16
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _createVNode("input", {
                            type: "radio",
                            ref: "option1",
                            id: "option1",
                            name: "option",
                            value: "1",
                            class: "radio-button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.computeTotalAmount(2000);})
                          }, null, 512),
                          _hoisted_21,
                          _createVNode("input", {
                            type: "radio",
                            ref: "option2",
                            id: "option2",
                            name: "option",
                            value: "2",
                            class: "radio-button",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.computeTotalAmount(5000);})
                          }, null, 512),
                          _hoisted_22
                        ])
                      ]),
                      _hoisted_23
                    ]),
                    _createVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode("label", _hoisted_28, [
                          _createVNode("b", null, _toDisplayString(_ctx.numberWithCommas(_ctx.totalAmount)) + " " + _toDisplayString(_ctx.currency), 1)
                        ])
                      ]),
                      _hoisted_29
                    ]),
                    (_ctx.topupfrom == 1)
                      ? (_openBlock(), _createBlock("div", _hoisted_30, [
                          _hoisted_31,
                          _createVNode("div", _hoisted_32, [
                            (_ctx.isProcessingReload == false && _ctx.isShowProceed == true)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "#",
                                  class: "btn btn-sm btn-success",
                                  "data-bs-toggle": "modal",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.process_matchinpayReload();})
                                }, " Proceed "))
                              : _createCommentVNode("", true),
                            (_ctx.isProcessingReload == true)
                              ? (_openBlock(), _createBlock("a", _hoisted_33, " Processing... "))
                              : _createCommentVNode("", true),
                            _hoisted_34,
                            (_ctx.isShowProceed == true)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 2,
                                  href: "#",
                                  class: "btn btn-sm btn-danger",
                                  "data-bs-dismiss": "modal",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.cancel_matchinpayReload();})
                                }, " Cancel "))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_35
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.topupfrom == 2)
                      ? (_openBlock(), _createBlock("div", _hoisted_36, [
                          _hoisted_37,
                          _createVNode("div", _hoisted_38, [
                            (_ctx.isProcessingReload == false && _ctx.isShowProceed == true)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: "#",
                                  class: "btn btn-sm btn-success",
                                  "data-bs-toggle": "modal",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.process_matchinpayReload_DLQR();})
                                }, " Proceed "))
                              : _createCommentVNode("", true),
                            (_ctx.isProcessingReload == true)
                              ? (_openBlock(), _createBlock("a", _hoisted_39, " Processing... "))
                              : _createCommentVNode("", true),
                            _hoisted_40,
                            (_ctx.isShowProceed == true)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 2,
                                  href: "#",
                                  class: "btn btn-sm btn-danger",
                                  "data-bs-dismiss": "modal",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.cancel_matchinpayReload();})
                                }, " Cancel "))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_41
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasPendingMatchinPayOTP == true )
                ? (_openBlock(), _createBlock("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        _withDirectives(_createVNode("input", {
                          type: "number",
                          class: "form-control form-control-solid",
                          id: "matchinpay_otp",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.model_matchinpay_otp = $event)),
                          placeholder: "Enter OTP"
                        }, null, 512), [
                          [_vModelText, _ctx.model_matchinpay_otp]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createVNode("div", _hoisted_48, [
                        (_ctx.isProcessingOTP == false)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "#",
                              class: "btn btn-sm btn-success",
                              "data-bs-toggle": "modal",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.process_matchinpayOTP();})
                            }, " Proceed "))
                          : _createCommentVNode("", true),
                        _hoisted_49,
                        (_ctx.isProcessingOTP == true)
                          ? (_openBlock(), _createBlock("a", _hoisted_50, " Processing.. "))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_51
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.loading]
      ])
    ])
  ], 64))
}